const permissions = {
  officeTools: 'officetools',
  agentTools: 'agenttools',
  translationTools: 'translationtools',
  cmsTools: 'cmstools',
}

export default permissions
